import { services } from "../data/siteData";

function Services() {
  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-heading">
          <p className="eyebrow">What We Do</p>
          <h2>Our Services</h2>
          <p className="section-subtext">
            Everything you need, from blinds to tracks, curtains, sheers and liners.
          </p>
        </div>

        <div className="services__grid">
          {services.map((service) => (
            <div className="service-card" key={service.title}>
              <div className="service-card__image">
                <img src={service.image} alt={service.title} loading="lazy" />
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
